import { SET_SIGN_IN_IS_VISIBLE } from './constants';

export const setSignInIsVisible = isVisible => ({
    type: SET_SIGN_IN_IS_VISIBLE,
    isVisible,
});



// WEBPACK FOOTER //
// ./src/containers/Inputs/SignIn/actions.js